import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startTime", "endTime"]

  updateTimeFields(evt) {
    const { startDate, endDate } = evt.detail

    if (startDate) {
      // Timepicker always uses local time, but SOC wants to input UTC.
      // utcOffset(0, true) keeps the same time values but interprets as UTC
      // e.g., 1:00 UTC-5 becomes 1:00 UTC (not 6:00 UTC)
      this.startTimeTarget.value = startDate.clone().utcOffset(0, true).toISOString()
    }
    if (endDate) {
      this.endTimeTarget.value = endDate.clone().utcOffset(0, true).toISOString()
    }
  }
}
